<template>
    <div
        class="education-item-wrapper"
        :class="{ _desktop: desktopAndMore, _tablet: tabletAndLess, _phone: phoneAndLess }"
    >
        <div class="description">
            <div class="education-type">
                <div class="circle"
                     :style="{ backgroundColor: types[education.educationType].color }"
                ></div>
                <div class="type-title">{{ types[education.educationType].title }}</div>
            </div>
            <div class="education-title">{{ education.name }}</div>
            <router-link
                :to="detailsLink"
                class="hover-link-underlined more"
                target="_blank"
            >Подробнее
            </router-link>
        </div>
        <div class="actions">
            <CustomDataPicker
                @on-change-date="changeDateHandler"
                v-if="education.isAnyTimeStart"
                :loading="calendarLoading"
                :centered="tabletAndLess"
                :scrollParent="scrollParent"
            >
                <template v-slot:activator="{ onActivate }">
                    <div
                        class="selectDate"
                        @click="onActivate"
                    >
                        Добавить дату старта
                    </div>
                </template>
            </CustomDataPicker>

            <ListDataPicker
                v-else
                :loading="calendarLoading"
                @on-change-date="changeDateHandler"
                :items="education.dateList"
                :centered="tabletAndLess"
            >
                <template v-slot:activator="{ onActivate }">
                    <div
                        class="selectDate"
                        :class="{ disable: !education.dateList.length }"
                        @click="onActivate"
                    >
                        Добавить дату старта
                    </div>
                </template>
            </ListDataPicker>

            <div
                class="first-date"
                v-if="!education.isAnyTimeStart"
            >
                Ближайшая дата: <span>{{ lastDate }}</span>
            </div>
            <div class="duration" v-if="duration">Длительность: <span>{{ duration }}</span></div>
            <div class="delete" @click="deleteItem">Удалить</div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import moment from 'moment';
import { parseDuration } from '../../../../../tools/humanize_duration';
import CustomDataPicker from './CustomDataPicker';
import ListDataPicker from './ListDataPicker';

const accountTrackActions = [
    'scheduleProgram',
    'removeProgram',
];
const popupsControllerActions = [
    'closePopup',
];
export default {
    name: 'EducationItem',
    components: {
        CustomDataPicker,
        ListDataPicker,
    },
    data: () => ({
        // isCalendar: false,
        calendarLoading: false,
        scrollParent: null,
        types: {
            higher: {
                title: 'Высшее образование',
                color: '#5EC1F9',
            },
            additional: {
                title: 'Дополнительное образование',
                color: '#AF77E1',
            },
            secondary: {
                title: 'Среднее образование',
                color: '#5EC1F9',
            },
            rsv_webinar: {
                title: 'Вебинар',
                color: '#4ACFC2',
            },
            rsv_course: {
                title: 'Онлайн-курс РСВ',
                color: '#F27E82',
            },
        },
    }),
    props: {
        education: Object,
        scrolledEl: null,
    },
    computed: {
        ...mapGetters(['width']),
        desktopAndMore() {
            return this.width > 768;
        },
        tabletAndLess() {
            return this.width <= 768;
        },
        phoneAndLess() {
            return this.width <= 415;
        },
        duration() {
            if (this.education.durationInterval) {
                return parseDuration(this.education.durationInterval);
            } else return null;
        },
        lastDate() {
            if (this.education.dateList.length) {
                return moment(this.education.dateList
                    .find(v => moment(new Date()).isBefore(v)))
                    .format("DD.MM.YYYY");
            } else {
                return 'не определена';
            }

        },
        detailsLink() {
            if (this.education.entityType === 'program') {
                return {
                    name: 'profession-program', 
                    params: {id: this.education.id},
                    query: { mView: 'detail'},
                };
            } else if (this.education.entityType === 'course') {
                return {
                    name: 'events', 
                    params: {type: 'courses', page: 1, id: this.education.foreignCmsId},
                    query: { mView: 'detail'},
                };
            } else if (this.education.entityType === 'webinar') {
                return {
                    name: 'events', 
                    params: {type: 'webinars', page: 1, id: this.education.foreignCmsId}, 
                    query: { mView: 'detail'},
                };
            } else if (this.education.entityType === 'full_time') {
                return {
                    name: 'events', 
                    params: {type: 'events', page: 1, id: this.education.foreignCmsId},
                    query: { mView: 'detail'},
                };
            }
            return '';
        },
    },
    methods: {
        ...mapActions('accountTrack', accountTrackActions),
        ...mapActions('popupsController', popupsControllerActions),
        async changeDateHandler({ date, popUpId }) {
            this.calendarLoading = true;
            await this.scheduleProgram({programId: this.education.id, startAt: date});
            this.calendarLoading = false;
            this.closePopup(popUpId);
        },
        deleteItem() {
            this.removeProgram({programId: this.education.id});
        },
    },
    watch: {
        scrolledEl: {
            handler(val) {
                this.scrollParent = val;
            },
            immediate: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.education-item-wrapper {
    width: 100%;
    background: #FFFFFF;
    border: 1px solid #D2D5D9;
    border-radius: 8px;
    display: flex;
    flex-direction: row;
    padding: 12px;

    .description {
        flex: 1;

        .education-type {
            display: flex;
            flex-direction: row;
            align-items: center;
            margin-bottom: 6px;

            .circle {
                background: #AF77E1;
                width: 8px;
                height: 8px;
                border-radius: 50%;
            }

            .type-title {
                margin-left: 6px;
                font-weight: 600;
                font-size: 12px;
                line-height: 16px;
                color: #98A0A9;
            }
        }

        .education-title {
            font-style: normal;
            font-weight: 600;
            font-size: 15px;
            line-height: 22px;
            color: #2A2626;
            margin-bottom: 6px;
        }

        .more {
            width: 67px;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            color: #4663AB;
            //border-bottom: 1px solid #3874E0;
            cursor: pointer;

            &:hover {
                //border-bottom: 1px solid transparent;
            }
        }
    }

    .actions {
        width: 176px;
        margin-left: 16px;

        .selectDate {
            width: 176px;
            height: 32px;
            background: #D9ECFF;
            border-radius: 4px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            text-align: center;
            color: #4663AB;
            cursor: pointer;
            margin-bottom: 6px;
            position: relative;

            &:hover {
                color: #FFFFFF;
                background: #4663AB;
            }

            &.disable {
                border: 2px solid #E0E3E5;
                color: #CCCCCC;
                background-color: #F7F7F8;
                cursor: not-allowed;
            }
        }

        .first-date {
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            color: #2A2626;
            margin-bottom: 6px;

            span {
                font-weight: 600;
                font-size: 12px;
                line-height: 16px;
                color: #2A2626;
            }
        }

        .duration {
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            color: #2A2626;
            margin-bottom: 6px;

            span {
                font-weight: 600;
                font-size: 12px;
                line-height: 16px;
                color: #2A2626;
            }
        }

        .delete {
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            color: #EF627D;
            cursor: pointer;

            &:hover {
                color: #E75671;
            }
        }
    }

    &._phone {
        padding: 12px 0 0;
        flex-direction: column;
        position: relative;
        overflow: hidden;

        .description {
            padding: 0 12px;
            position: relative;

            .more {
                position: absolute;
                top: 100%;
            }

            .education-type {
                margin-bottom: 8px;
            }

            .education-title {
                margin-bottom: 12px;
            }
        }

        .actions {
            margin-left: 0;
            width: 100%;
            display: flex;
            flex-direction: column-reverse;

            .selectDate {
                width: 100%;
                margin-bottom: 0;
                border-radius: 0;
            }

            .popup {
                left: 0 !important;
                right: 0 !important;
            }

            .first-date {
                order: 1;
                text-align: right;
                padding-right: 12px;
                padding-left: 91px;
            }

            .duration {
                text-align: right;
                padding-right: 12px;
                margin-bottom: 16px;
                padding-left: 91px;
            }

            .delete {
                position: absolute;
                top: 12px;
                right: 12px;
            }
        }

    }

    &:last-child {
        margin-bottom: 24px !important;
    }
}
</style>
